'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _codingactivity = require('./codingactivity.html');

var _codingactivity2 = _interopRequireDefault(_codingactivity);

var _codingactivity3 = require('./codingactivity.controller');

var _codingactivity4 = _interopRequireDefault(_codingactivity3);

require('./codingactivity.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var codingactivityComponent = {
  restrict: 'E',
  bindings: {},
  template: _codingactivity2.default,
  controller: _codingactivity4.default,
  controllerAs: 'vm'
};

exports.default = codingactivityComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/codingactivity/codingactivity.component.js